module.exports = __webpack_public_path__ + "static/Unity_Tower_lower_floor_modern_v2-f1faeb2be16cad6d983be7ddc23b5df7.png";